import Vue from "vue";
import Vuetify from "vuetify/lib";
import colors from "vuetify/lib/util/colors";
// import { Plugin } from "vue-fragment";
import VueMask from "v-mask";
import { VueMaskDirective } from "v-mask";
import { VueMaskFilter } from "v-mask";
import frag from "vue-frag";
import VueYoutube from "vue-youtube";
// import VueFakeInput from 'vue-fake-input';

// Vue.use(VueFakeInput);

Vue.use(Vuetify);
Vue.use(VueYoutube);
// Vue.use(Plugin);
Vue.directive("frag", frag);
Vue.use(VueMask);
Vue.directive("mask", VueMaskDirective);
Vue.filter("VMask", VueMaskFilter);
export default new Vuetify({
  icons: {
    iconfont: "mdiSvg" // default - only for display purposes
  },
  theme: {
    themes: {
      light: {
        background: "#f4f7f9",
        cardOne: "#ffffff",
        primary: "#E50050",
        secondary: "#9D172F",

        primaryApp: colors.white,
        secondaryApp: colors.grey.lighten3,
        btnSuccess: "#E50050",
        btnCancel: "#878786",
        info: colors.grey.darken1,
        Colorsuccess: colors.green,
        modify: "#E50050"
      }
    }
  }
});
